import { ReceiptIcon } from '@/components/icons';
import { Button } from '@/components/ui';
import styles from '@/styles/components/SelectionBar/style.scss';

interface SelectionBarProps {
  count: number;
  onClear: () => void;
  /** Omitted when bookings are ticked on several tables (Generate Bill is in the page header then). */
  onGenerateBill?: () => void;
}

/** Clear and (for a single table) Generate Bill, shown while ended bookings are ticked on this card. */
export function SelectionBar({ count, onClear, onGenerateBill }: SelectionBarProps) {
  if (count === 0) return null;

  return (
    <div className={styles.bar}>
      <span className={styles.count}>{count} selected</span>
      <Button variant="ghost" size="sm" onClick={onClear} className={styles.clear}>
        Clear
      </Button>
      {onGenerateBill && (
        <Button
          variant="primary"
          size="sm"
          icon={<ReceiptIcon size={16} />}
          aria-label={`Generate bill for ${count} ${count === 1 ? 'booking' : 'bookings'}`}
          onClick={onGenerateBill}
        >
          Generate Bill
        </Button>
      )}
    </div>
  );
}
